import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../../lib/supabase'

interface Branch {
  id: string
  name: string
}

async function fetchBranches(): Promise<Branch[]> {
  const { data, error } = await supabase
    .from('branches')
    .select('id, name')
    .eq('status', 'active')
    .order('name')

  if (error) throw error
  return data
}

export function useBranches() {
  return useQuery({
    queryKey: ['branches'],
    queryFn: fetchBranches,
  })
}